import React from 'react';
import { Dashboard, PageLayout } from '@components/common';
import { LeavingGuard } from '@components/utils/LeavingGuard';
import { BackButton, Dropdown, Fieldset, Loading, Subsection, Tag, ToolbarButton, } from '@fourthwall/components';
import { ArrowShortDownIcon, DotsHorizontalIcon } from '@fourthwall/icons';
import { ConfirmBar } from '@modules/Dashboard/modules/ConfirmBar';
import { routing } from '@utils/routing';
import { isPaidTier } from '../../utils';
import { TierSkeleton } from './TierSkeleton';
import { useTierContext } from './hooks/useTierContext';
import { Analytics } from './modules/Analytics';
import { AskForShippingAddress } from './modules/AskForShippingAddress';
import { Description } from './modules/Description';
import { Discount } from './modules/Discount';
import { DiscountType } from './modules/DiscountType';
import { Image } from './modules/Image';
import { InternationalPricing } from './modules/InternationalPricing';
import { MonthDiscount } from './modules/MonthDiscount';
import { Price } from './modules/Price';
import { TimeLimit } from './modules/TimeLimit';
import { Title } from './modules/Title';
import { YearDiscount } from './modules/YearDiscount';
import { TierProvider } from './providers/TierProvider';
const TierContent = () => {
    const { tier, form, isLoading, isPriceRatesLoading, publishTier, unpublishTier, deleteTier, deleteFreeTier, } = useTierContext();
    if (!tier)
        return React.createElement(TierSkeleton, null);
    return (React.createElement(Loading, { isLoading: isLoading },
        React.createElement(PageLayout, { leftContent: React.createElement(React.Fragment, null,
                React.createElement(Subsection, { title: "Tier details" },
                    React.createElement(Fieldset, null,
                        React.createElement(Title, null),
                        React.createElement(Description, null),
                        React.createElement(Image, null))),
                React.createElement(Subsection, { title: "Pricing" },
                    React.createElement(Fieldset, null,
                        React.createElement(Price, null),
                        React.createElement(InternationalPricing, null),
                        React.createElement(Discount, null),
                        React.createElement(DiscountType, null),
                        React.createElement(MonthDiscount, null),
                        React.createElement(YearDiscount, null),
                        React.createElement(TimeLimit, null))),
                isPaidTier(tier) && (React.createElement(Subsection, { title: "Advanced" },
                    React.createElement(AskForShippingAddress, null)))), rightContent: React.createElement(Analytics, null) },
            React.createElement(Dashboard.Section, { name: tier.name, topContent: React.createElement(BackButton, { label: "Perks & tiers", to: routing.memberships.perks.self }), toolbarContent: React.createElement(React.Fragment, null,
                    isPaidTier(tier) && (React.createElement(Dropdown, { content: React.createElement(Dropdown.Item, { label: tier.status === 'Published' ? 'Unpublish' : 'Publish', onClick: tier.status === 'Published' ? unpublishTier : publishTier }), position: "bottom-end" },
                        React.createElement("div", null,
                            React.createElement(Tag, { label: tier?.status === 'Published' ? 'Published' : 'Unpublished', appearance: tier?.status === 'Published' ? 'success' : 'default', icon: ArrowShortDownIcon, hoverable: true, size: "large" })))),
                    React.createElement(Dropdown, { content: React.createElement(Dropdown.Item, { label: "Delete", onClick: isPaidTier(tier) ? deleteTier : deleteFreeTier }), position: "bottom-end" },
                        React.createElement(ToolbarButton, { label: "Settings", icon: DotsHorizontalIcon }))), titleSpacing: "medium", bottomMargin: "large" })),
        React.createElement(LeavingGuard, { when: form.dirty, isValid: form.isValid, onSave: form.submitForm }),
        React.createElement(ConfirmBar, { isOpen: form.dirty, isLoading: isLoading || isPriceRatesLoading, onConfirm: form.submitForm, onCancel: form.resetForm })));
};
export const Tier = () => {
    return (React.createElement(TierProvider, null,
        React.createElement(TierContent, null)));
};
